import * as React from "react";
const SvgPlus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    width="0.8em"
    height="0.8em"
    {...props}
  >
    <path
      d="M7 1a1 1 0 1 1 2 0v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 1 1 0-2h6z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPlus;
